/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LaborActivityDto } from '../../models/labor-activity-dto';
import { UpdateLaborActivityRequest } from '../../models/update-labor-activity-request';

export interface UpdateLaborActivity$Params {
  id: string;
      body: UpdateLaborActivityRequest
}

export function updateLaborActivity(http: HttpClient, rootUrl: string, params: UpdateLaborActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborActivityDto>> {
  const rb = new RequestBuilder(rootUrl, updateLaborActivity.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LaborActivityDto>;
    })
  );
}

updateLaborActivity.PATH = '/v0/laborActivities/{id}';
